import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, HTMLSelect, InputGroup, TextArea, Switch, RadioGroup, Radio } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { IEmpresa, newEmpresa } from "../../model";
import { toast } from "react-toastify";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj } from "../../utils";
import IntlCurrencyInput from "react-intl-currency-input";
import QRCode from "qrcode.react";
import { BootstrapTable, SearchField, TableHeaderColumn, } from "react-bootstrap-table";
import moment from "moment";
import { PgdasStore } from "../../stores/pgdas/PgdasStore";
import { AppIcon } from "../utils/AppIcon";
const numeral = require("numeral");
const currencyConfig = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

interface State {
  listEmpresas: any[];
}

@observer
export default class SolicitaPgdas extends React.Component<{}, State> {

  obs = observable({
    selectEmpresa: newEmpresa() as IEmpresa,
    open_buy_chave: false as boolean,
    quantidade: "" as string,
    valor_total: 0 as number,
    credito_restantes: 0 as number,
    count: 0 as number,
    pagamento_pix: false as boolean,
    interval: [] as any,
    ano: "2023" as string,
    competencia: "01" as string,
    retificar: false as boolean,
    filiais: true as boolean,
    selected_regime: "" as string,
    valor_adicional: "" as string,
    optante: true as boolean,
    esfera: 0 as number,
    processo: "" as string,
    gerar_das: false as boolean,
    open_filiais: false as boolean,
  })

  constructor(props: any) {
    super(props);

    this.state = {
      listEmpresas: []
    };
  }

  async componentDidMount() {
    this.obs.ano = moment(new Date()).format("YYYY")
  }

  handleFormataReal(vl: string): string {
    let str = vl.replace("R$", "").trim().replace(",", "").replace(".", "");
    let total = str.length;
    let inicio = str.slice(0, total - 2);
    let fim = str.slice(total - 2);

    return (inicio + "." + fim);
  }

  handleCheckEmpresas = async (check, row) => {

    if (check) {

      this.setState({ listEmpresas: row?.map(value => value.cnpj) });

    } else {

      this.setState({ listEmpresas: [] });
    }

  };

  createCustomSearchFieldSol = (props) => {
    return (
      <SearchField
        className="input-filter input-filter-sefa"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );
  };

  handleCloseFiliais = () => {
    this.obs.open_filiais = false;
  };

  handleConcluirFiliais = () => {
    if (this.state.listEmpresas.length === 0) {
      toast.warning("Selecione pelo menos uma filial.", {});
      return;
    }

    this.obs.open_filiais = false;
  };

  handleSelectEmpresa = (empresa: IEmpresa) => {
    this.obs.selectEmpresa = empresa;

    this.obs.filiais = true;

    this.obs.open_filiais = false;

    this.setState({
      listEmpresas: []
    });
  };

  handleFiliaisChange = (checked: boolean) => {
    this.obs.filiais = checked;

    if (!checked) {
      this.obs.open_filiais = true;
    } else {
      this.obs.open_filiais = false;

      this.setState({
        listEmpresas: []
      });
    }
  };

  async handleCriarTransmissao() {
    if (this.obs.selectEmpresa.cnpj === "") {
      toast.warning('Selecione uma empresa.', {});
      return;
    }

    if (!this.obs.filiais && this.state.listEmpresas.length === 0) {
      toast.warning("Selecione pelo menos uma filial.", {});
      this.obs.open_filiais = true;
      return;
    }

    if (!this.obs.competencia) {
      toast.warning('Selecione uma competência.', {});
      return;
    }
    if (!this.obs.ano) {
      toast.warning('Selecione um ano.', {});
      return;
    }

    if (!this.obs.optante) {

      if (this.obs.esfera == 0) {
        toast.warning('Selecione uma Esfera.', {});
        return;
      }
      if (this.obs.processo == "") {
        toast.warning('Digite o código do processo.', {});
        return;
      }
    }

    PgdasStore.obs.transmitirPgdas = false

    const filiaisSelecionadas = this.obs.filiais
      ? this.getFiliaisMatriz().map(empresa => empresa.cnpj)
      : this.state.listEmpresas;

    await PgdasStore.handleTransmissao(
      this.obs.selectEmpresa.cnpj,
      this.obs.competencia,
      this.obs.ano,
      this.obs.retificar,
      this.obs.selected_regime,
      this.handleFormataReal(this.obs.valor_adicional),
      this.obs.esfera,
      this.obs.processo,
      this.obs.gerar_das,
      filiaisSelecionadas,
      this.obs.filiais
    );
  }

  handleMonths() {
    return (<>
      <option value="01">Janeiro</option>
      <option value="02">Fevereiro</option>
      <option value="03">Março</option>
      <option value="04">Abril</option>
      <option value="05">Maio</option>
      <option value="06">Junho</option>
      <option value="07">Julho</option>
      <option value="08">Agosto</option>
      <option value="09">Setembro</option>
      <option value="10">Outubro</option>
      <option value="11">Novembro</option>
      <option value="12">Dezembro</option>
    </>);
  }

  handleAnos() {
    let m = moment();
    let ano = m.year() - 1;

    return (<>
      <option value={ano + 1}>{ano + 1}</option>
      <option value={ano}>{ano}</option>
    </>)
  }

  handleChangeCompetencia(competencia: string) {
    if (competencia != "1") { this.obs.selected_regime = "" }
    this.obs.competencia = competencia
  }

  handleCloseProgramar() {
    PgdasStore.obs.transmitirPgdas = false;
    this.obs.ano = moment(new Date()).format("YYYY")
    this.obs.selectEmpresa = newEmpresa();
  }

  handleCheckEmpresaChange = (row: any, checked: boolean) => {
    this.setState(state => {
      if (checked) {
        return {
          listEmpresas: [...state.listEmpresas, row.cnpj]
        };
      }

      return {
        listEmpresas: state.listEmpresas.filter(cnpj => cnpj !== row.cnpj)
      };
    });
  };

  getFiliaisMatriz = () => {
    const cnpjBase = this.getCnpjBase(this.obs.selectEmpresa.cnpj);

    if (!cnpjBase) {
      return [];
    }

    return EmpresaStore.sortedEmpresas.filter((empresa: IEmpresa) => {
      return (
        this.isFilial(empresa.cnpj) &&
        this.getCnpjBase(empresa.cnpj) === cnpjBase
      );
    });
  };

  getCnpjNumeros = (cnpj: string) => {
    return (cnpj || "").replace(/\D/g, "");
  };

  getCnpjBase = (cnpj: string) => {
    return this.getCnpjNumeros(cnpj).substring(0, 8);
  };

  isMatriz = (cnpj: string) => {
    const cnpjNumeros = this.getCnpjNumeros(cnpj);

    if (cnpjNumeros.length !== 14) {
      return false;
    }

    return cnpjNumeros.substring(8, 12) === "0001";
  };

  isFilial = (cnpj: string) => {
    const cnpjNumeros = this.getCnpjNumeros(cnpj);

    if (cnpjNumeros.length !== 14) {
      return false;
    }

    return cnpjNumeros.substring(8, 12) !== "0001";
  };

  render() {
    let empresaText = this.obs.selectEmpresa.cnpj != ""
      ? `${this.obs.selectEmpresa.razao_social} (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
      : "Selecione uma empresa";

    const options_soli = {
      searchField: this.createCustomSearchFieldSol,
    };

    const currencyConfig = {
      locale: "pt-BR",
      formats: {
        number: {
          BRL: {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          },
        },
      },
    };

    let empresas = this.getFiliaisMatriz().map(emp => {
      return {
        _id: emp._id,
        razao_social: emp.razao_social,
        cnpj: emp.cnpj,
        cnpj_formated: formatCnpj(emp.cnpj)
      };
    });

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleCheckEmpresaChange,
      onSelectAll: this.handleCheckEmpresas,
      selected: this.state.listEmpresas,
    };

    const matrizes = EmpresaStore.sortedEmpresas.filter(
      (empresa: IEmpresa) =>
        empresa.lista_rbt12 &&
        empresa.simples_nacional &&
        this.isMatriz(empresa.cnpj)
    );

    return (
      <>
        <FormGroup className="empresaSelect" label="Empresa">
          <EmpresaSelect
            items={matrizes}
            itemRenderer={renderEmpresa}
            itemPredicate={filterEmpresa}
            onItemSelect={(empresa: IEmpresa) =>
              this.handleSelectEmpresa(empresa)
            }
            inputProps={{
              placeholder: "Filtrar uma matriz"
            }}
          >
            <Button
              text={empresaText}
              rightIcon="double-caret-vertical"
              alignText={Alignment.LEFT}
            />
          </EmpresaSelect>
        </FormGroup>

        {this.obs.selectEmpresa.cnpj !== "" && (
          <div style={{ display: "flex", gap: 10 }}>
            <FormGroup label="Enviar todas as filiais" />

            <Switch
              innerLabelChecked="Sim"
              innerLabel="Não"
              checked={this.obs.filiais}
              onChange={(e: any) => this.handleFiliaisChange(e.target.checked)}
            />
            {!this.obs.filiais && (
              <span style={{cursor: "pointer", textAlign: "right"}}
                onClick={() => {
                  this.obs.open_filiais = true;
                }}>
                <AppIcon name="edit" size={14}/>&nbsp;&nbsp;
                <b>
                Selecionar filiais ({this.state.listEmpresas.length})
              </b>
              </span>
            )}
          </div>
        )}

        <FormGroup label="Competência:" className="inputsPeriodoCalculos">
          <HTMLSelect
            value={this.obs.competencia}
            onChange={(e) => this.handleChangeCompetencia(e.target.value)}
            disabled={false}
          >
            {this.handleMonths()}
          </HTMLSelect>
        </FormGroup>

        <FormGroup label="Ano:" className="inputsPeriodoCalculos">
          <HTMLSelect
            value={this.obs.ano}
            onChange={(e) => { this.obs.ano = e.target.value }}
            disabled={false}
          >
            {this.handleAnos()}
          </HTMLSelect>
        </FormGroup>

        {this.obs.competencia == "11" &&
          <>
            <p><b>Obs:</b> Antes de efetuar a apuração desejada, é necessário definir o regime de apuração das receitas para o <br /> ano-calendário de {moment().add(1, "years").format("YYYY")}. Caso já tenha realizado selecione <b>Ignorar</b>.</p>

            <RadioGroup onChange={(e: any) => this.obs.selected_regime = e.target.value} selectedValue={this.obs.selected_regime}>
              <Radio label="Ignorar" value="" />
              <Radio label="Caixa" value="caixa" />
              <Radio label="Competência" value="competencia" />
            </RadioGroup>

          </>
        }

        <FormGroup label="Valor adicional">
          <IntlCurrencyInput
            className="form-control"
            onChange={(e: any) => { this.obs.valor_adicional = e.target.value }}
            currency="BRL"
            config={currencyConfig}
          />
        </FormGroup>

        <div style={{ display: "flex", verticalAlign: "middle" }}>
          <FormGroup label="Gerar DAS automaticamente após a Transmissão:" />
          <Switch
            innerLabelChecked="Sim"
            innerLabel="Não"
            checked={this.obs.gerar_das}
            onChange={(e: any) => this.obs.gerar_das = e.target.checked}
            style={{ marginTop: "2px", marginLeft: 5 }}
          />
        </div>

        <MDBRow>
          <MDBCol md="4">
            <div style={{ display: "flex", verticalAlign: "middle" }}>
              <FormGroup label="Retificar" />
              <Switch
                innerLabelChecked="Sim"
                innerLabel="Não"
                checked={this.obs.retificar}
                onChange={(e: any) => this.obs.retificar = e.target.checked}
                style={{ marginTop: "2px", marginLeft: 5 }}
              />
            </div>
          </MDBCol>
          <MDBCol md="4">
            <div style={{ display: "flex", verticalAlign: "middle" }}>
              <FormGroup label="Optante" />
              <Switch
                innerLabelChecked="Sim"
                innerLabel="Não"
                checked={this.obs.optante}
                onChange={(e: any) => this.obs.optante = e.target.checked}
                style={{ marginTop: "2px", marginLeft: 5 }}
              />
            </div>
          </MDBCol>
        </MDBRow>
        {!this.obs.optante &&
          <>

            <FormGroup label="Esfera" className="inputsPeriodoCalculos">
              <HTMLSelect
                value={this.obs.esfera}
                onChange={(e) => this.obs.esfera = parseInt(e.target.value)}
              >
                <option value={0}>Selecione</option>
                <option value={1}>Federal</option>
                <option value={2}>Distrial</option>
                <option value={3}>Estadual</option>
                <option value={4}>Municipal</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label="Processo">
              <InputGroup
                value={this.obs.processo}
                onChange={(e: any) => this.obs.processo = e.target.value}
              />
            </FormGroup>

          </>
        }

        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button text="Cancelar" onClick={() => this.handleCloseProgramar()} />
          <Button text="Transmitir" intent="primary" onClick={() => this.handleCriarTransmissao()} />
        </div>


        <Dialog
          usePortal={true}
          isOpen={this.obs.open_filiais}
          onClose={() => this.handleCloseFiliais()}
          className="AlertUser modalSefa"
        >
          <h2 className="titleSEFAZ modal-sefa">Filiais</h2>

          <FormGroup
            label="Selecione as filiais:"
            labelFor="empresas"
          >
            <div className="select-empresa-sefa">
              <BootstrapTable data={empresas} selectRow={selectRowProp} options={options_soli} search>
                <TableHeaderColumn dataField="cnpj" isKey={true} hidden width="0%"> # </TableHeaderColumn>
                <TableHeaderColumn dataField="razao_social" width="65%"> Razão Social </TableHeaderColumn>
                <TableHeaderColumn dataField="cnpj_formated" width="20%"> CNPJ </TableHeaderColumn>
              </BootstrapTable>
            </div>
          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" onClick={() => this.handleCloseFiliais()} />
            <Button text="Concluir" intent="primary" onClick={() => this.handleConcluirFiliais()} />
          </div>
        </Dialog>

      </>
    )
  }
}
